import EditMyListProductModal from 'components/GlobalModals/EditMyListProductModal/EditMyListProductModal';
import { withEditMyListProductModalProps } from 'viewModel/globalModals/editMyListProductModal/withEditMyListProductModalProps';

const ConnectedEditMyListProductModalProps = withEditMyListProductModalProps(EditMyListProductModal);

export default ConnectedEditMyListProductModalProps;
